var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-profile-detail"},[_c('ProfileOptionSelector',{attrs:{"model":'university',"nextRoute":() => `OnboardWhyDifficult`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }